"use client";
import React from "react";
import { anavatanCities } from "@/config/enums/anavatanCities.enum";
import { Button } from "@nextui-org/react";
import classNames from "classnames";

const SelectProvince = ({ instance, setSelectedCity }) => {
  const [selectedCity, setLocalSelectedCity] = React.useState(null);
  return (
    <div className="lg:px-5 relative z-20 w-full pointer-events-none opacity-50">
      <div className="md:container md:mx-auto z-30 relative">
        <div className="overflow-hidden lg:bg-[var(--surface-inverted-primary)] rounded-xl w-full z-99 relative pb-3">
          <div className="w-full bg-[var(--surface-positive-primary)] h-[6px] lg:block hidden" />
          <div className="w-full bg-[var(--content-inverted-primary)] h-[6px] lg:block hidden" />
          <div className="w-full bg-[var(--surface-negative-primary)] h-[6px] lg:block hidden" />
          <div className="text-primary-white lg:mr-8 ms:mr-0">
            <div className="text-2xl p-0 py-5 lg:px-5">
              <h2 className="pb-4 mr-5 lg:mr-0">
                محتوای استان خود را تماشا کنید.
              </h2>
              <div className="w-full flex overflow-x-auto gap-4 px-5">
                {anavatanCities?.map((city, index) => {
                  return (
                    <Button
                      onClick={() => {
                        // setLocalSelectedCity(city);
                        // setSelectedCity(city);
                        // instance?.slideTo(index);
                      }}
                      disableRipple
                      key={city.id}
                      variant={
                        selectedCity?.id === city.id || city.id === 0
                          ? "solid"
                          : "bordered"
                      }
                      size="lg"
                      color={
                        selectedCity?.id === city.id || city.id === 0
                          ? "primary"
                          : "light"
                      }
                      className={classNames(
                        "text-primary-white min-w-fit",
                        city.style
                      )}
                    >
                      {city.name}
                    </Button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectProvince;
